import { render, staticRenderFns } from "./CartItem.vue?vue&type=template&id=18ad0fa6&"
import script from "./CartItem.vue?vue&type=script&lang=js&"
export * from "./CartItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OpusIcon: require('/~/src/modules/opus/components/Icon.vue').default,OpusQuantitySelector: require('/~/src/modules/opus/components/QuantitySelector.vue').default,InsuranceProductCard: require('/~/src/modules/opus-ecom/components/Catalog/InsuranceProductCard.vue').default})
